import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Share2 } from "@digital-twins/design-system/icons";
import { Button } from "@/components/ui/button";
import { CollectionShareDialog } from "@/components/library/CollectionShareDialog";
import { useCollectionShareAdapter } from "@/hooks/useCollectionShareAdapter";
import { useAuth } from "@/lib/config/auth-provider";
import type { BrandShareButtonProps } from "@/types/creative-library";
export function BrandShareButton({ brand, onChanged }: BrandShareButtonProps) {
  const { t } = useTranslation("app");
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const adapter = useCollectionShareAdapter(
    brand.isOwner ? brand.collectionToken : null,
    user?.organizationToken,
  );
  if (!adapter) return null;
  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setOpen(true)}
        aria-label={t("creativeLibrary.share")}
        data-testid={`creative-brand-share-${brand.token}`}
      >
        <Share2 className="h-4 w-4" />
      </Button>
      <CollectionShareDialog
        title={t("creativeLibrary.shareBrand")}
        open={open}
        onOpenChange={(next) => {
          setOpen(next);
          if (!next) onChanged();
        }}
        adapter={adapter}
      />
    </>
  );
}
